/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.20.0
 * @since 1.19.0
 */

import styled from 'styled-components';

import { ScrollbarStyled } from '../../../../components/common';
import { fonts } from '../../../../theme';

export const WizardMultiSearchSubscribersStyled = styled.div.attrs({
    className: 'multi-search-subscribers',
})`

    display: grid;
    grid-template-columns: fit-content(400px) fit-content(400px) auto;
    column-gap: 32px;

    .multi-search-subscribers__title {
        ${fonts.textMainBold};
        margin-bottom: 12px;
    }

    .multi-search-subscribers__list {
        ${ScrollbarStyled};
    }
`;
